import { ImportStatusService } from './api/ImportStatusService'
import { ImportStatusModelData } from './models/ImportStatusModel'

const ImportStatusModule = {
  namespaced: true,
  state: ImportStatusModelData(),
  getters: {
    fetchImportStatusList: state => state.importStatusList,
    fetchQueryParams: state => state.queryParams
  },
  mutations: {
    setImportStatusList (state, data) {
      state.importStatusList = data.list
    },
    addQueryParams (state, queryParams) {
      state.queryParams = queryParams
    },
    setFilename (state, filename) {
      state.filename = filename
    }
  },
  actions: {
    /**
     * Get Import Status list
     *
     * @param commit | function
     * @param resolve | function
     * @param reject | function
     * @param param | object
     */
    async getImportStatusList ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      try {
        const response = await ImportStatusService.fetchImportStatusList(queryParams)
        const { success, data } = response.data
        if (success === true) {
          commit('setImportStatusList', {
            list: data.list
          })
          resolve && resolve(data)
        } else {
          commit('setImportStatusList', {
            list: []
          })
          reject && reject(data)
        }
      } catch (error) {
        reject && reject(error)
      }
    },
    /**
         * Get Export adoption list
         *
         * @param commit | function
         * @param resolve | function
         * @param reject | function
         * @param param | object
         */
    async downloadImportedFile ({ state, commit }, { resolve, reject }) {
      let queryParams = state.queryParams
      let filename = state.filename
      try {
        const response = await ImportStatusService.downloadImportedFile(queryParams, filename)
        resolve && resolve(response)
      } catch (error) {
        reject && reject(error)
      }
    }
  }
}
export default ImportStatusModule
